export interface ContactsProcessApiConfig {
	baseUrl: string;
}

export function loadContactsProcessApiConfig(): ContactsProcessApiConfig {
	const { CONTACTS_PROCESS_API } = process.env;

	if (!CONTACTS_PROCESS_API) {
		throw new Error("CONTACTS_PROCESS_API config is not set.");
	}

	return {
		baseUrl: CONTACTS_PROCESS_API
	};
}
